export default __webpack_public_path__ + "static/iconography-02-dont-9da6b33b93f1f436d4a3790b88546922baa8c2e1c819e657e9e37d15aecd3c4a.png";